import * as React from 'react';
import {
  Building2,
  Contact,
  FileText,
  LayoutGrid,
  MapPin,
  Settings,
  Store,
  Wrench,
  type LucideIcon,
} from 'lucide-react';
import type { QuickSearchResultType } from '@/components/quick-search/quick-search-types';

const TYPE_ICONS: Record<QuickSearchResultType, LucideIcon> = {
  page: LayoutGrid,
  tool: Wrench,
  config: Settings,
  site: Building2,
  dealer: Store,
  contact: Contact,
  sop: FileText,
  report: FileText,
};

const PAGE_ID_ICONS: Record<string, LucideIcon> = {
  'page:reports-admin': FileText,
  'page:sites-admin': Building2,
  'page:contacts': Contact,
  'page:operator-simulator': MapPin,
};

export function quickSearchResultIcon(type: QuickSearchResultType, resultId: string): LucideIcon {
  return PAGE_ID_ICONS[resultId] ?? TYPE_ICONS[type];
}
